import React, { useState, useEffect } from "react";
import { formatCurrency, parseCurrency } from "../../../utils/SamuiUtils";
import {
  formatThaiDateUi,
  formatThaiDate,
  formatThaiDateUi2,
} from "../../../utils/DateUtils";

import Datetime from "react-datetime";
import moment from "moment";

const SoModal = ({
  showSoModal,
  handleSoClose,
  soDataList,
  onConfirmSoSelection,
  arId,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [startDate, setStartDate] = useState(
    formatThaiDateUi2(moment().startOf("month").toDate())
  );
  const [endDate, setEndDate] = useState(
    formatThaiDateUi2(moment().endOf("month").toDate())
  );
  const [filteredSoDataList, setFilteredSoDataList] = useState([]);

  useEffect(() => {
    setFilteredSoDataList(
      soDataList.filter(
        (so) =>
          (so.Doc_No.toLowerCase().includes(searchTerm.toLowerCase()) ||
            so.AR_Name.toLowerCase().includes(searchTerm.toLowerCase())) &&
          parseCurrency(so.AR_ID) === parseCurrency(arId) &&
          (!startDate ||
            !endDate ||
            moment(formatThaiDate(so.Doc_Date)).isBetween(
              startDate,
              endDate,
              "day",
              "[]"
            ))
      )
    );
  }, [searchTerm, startDate, endDate, soDataList, arId]);

  useEffect(() => {
    if (showSoModal) {
      setSearchTerm("");
      setSelectedItems([]);
      setStartDate(
        moment(
          Math.min(
            ...soDataList.map(
              (rec) => new Date(formatThaiDate(rec.Doc_Date || new Date()))
            )
          )
        )
      );
      setEndDate(
        moment(
          Math.max(
            ...soDataList.map(
              (rec) => new Date(formatThaiDate(rec.Doc_Date || new Date()))
            )
          )
        )
      );
    }
  }, [showSoModal]);

  const handleCheckboxChange = (so) => {
    const updatedSelectedItems = selectedItems.some(
      (item) => item.Doc_No === so.Doc_No
    )
      ? selectedItems.filter((item) => item.Doc_No !== so.Doc_No)
      : [...selectedItems, so];

    setSelectedItems(updatedSelectedItems);
  };

  const handleConfirmSelection = () => {
    onConfirmSoSelection(selectedItems);
  };

  const clearSelection = () => {
    setSelectedItems([]);
  };

  return (
    <>
      <div
        className={`modal ${showSoModal ? "show" : ""}`}
        style={{ display: showSoModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">รายชื่อใบขาย</h5>
              <button type="button" className="close" onClick={handleSoClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <span className="fw-bold">ค้นหาเอกสาร</span>
                    <input
                      style={{ width: "100%" }}
                      type="text"
                      className="form-control"
                      placeholder="ค้นหาใบขาย (SO)"
                      value={searchTerm || ""}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <span className="fw-bold">วันที่เริ่มต้น</span>
                    <Datetime
                      className="input-spacing-input-date"
                      value={startDate}
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      onChange={(date) => setStartDate(date)}
                      inputProps={{ readOnly: true, disabled: false }}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group">
                    <span className="fw-bold">วันที่สิ้นสุด</span>
                    <Datetime
                      className="input-spacing-input-date"
                      value={endDate}
                      dateFormat="DD-MM-YYYY"
                      timeFormat={false}
                      onChange={(date) => setEndDate(date)}
                      inputProps={{ readOnly: true, disabled: false }}
                    />
                  </div>
                </div>
              </div>
              {/* ดึงจากใบขาย */}
              <div
                className="table-responsive"
                style={{ maxHeight: "600px", overflowY: "auto" }}
              >
                <table className="table table-striped table-hover">
                  <thead className="thead-dark">
                    <tr>
                      <th className="text-center" style={{ width: "1%" }}>
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSelectedItems(checked ? filteredSoDataList : []);
                          }}
                          checked={
                            filteredSoDataList.length > 0 &&
                            selectedItems.length === filteredSoDataList.length
                          }
                        />
                      </th>
                      <th className="text-center" style={{ width: "15%" }}>
                        เลขที่เอกสาร (SO)
                      </th>
                      <th className="text-center" style={{ width: "10%" }}>
                        วันที่เอกสาร
                      </th>
                      <th className="text-center" style={{ width: "32%" }}>
                        ชื่อลูกค้า
                      </th>
                      <th className="text-center" style={{ width: "32%" }}>
                        รายละเอียดเอกสาร
                      </th>
                      <th className="text-center" style={{ width: "10%" }}>
                        ราคารวม
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredSoDataList.length > 0 ? (
                      filteredSoDataList.map((so, index) => (
                        <tr
                          key={so.Doc_ID || index + 1}
                          onClick={() => handleCheckboxChange(so)}
                          style={{
                            cursor: "pointer",
                            backgroundColor: selectedItems.some(
                              (item) => item.Doc_No === so.Doc_No
                            )
                              ? "rgb(105, 188, 216)"
                              : "transparent",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={selectedItems.some(
                                (item) => item.Doc_No === so.Doc_No
                              )}
                              onChange={() => handleCheckboxChange(so)}
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td className="text-center">{so.Doc_No}</td>
                          <td className="text-center">
                            {formatThaiDateUi(so.Doc_Date)}
                          </td>
                          <td className="text-left">{so.AR_Name}</td>
                          <td className="text-left">{so.Doc_Remark1}</td>
                          <td className="text-end">
                            {formatCurrency(so.NetTotal)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <center>
                            <h5>ไม่พบข้อมูล</h5>
                          </center>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                onClick={handleConfirmSelection}
              >
                ยืนยันการเลือก
              </button>
              <button className="btn btn-danger" onClick={clearSelection}>
                ยกเลิกการเลือก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SoModal;
